import { NgModule } from '@angular/core';
import { INFOBLOCK_NORMALIZER, OccInfoblockNormalizer } from './converters/occ-infoblock-normalizer';

@NgModule({
  providers: [
    {
      provide: INFOBLOCK_NORMALIZER,
      useExisting: OccInfoblockNormalizer,
      multi: true,
    },
  ],
})
export class MainInfoblockUtilsModule {}
